import Mock from 'mockjs'

const MOCK030002 = Mock.mock({
    'respCode': '0000',
    'respMsg': '',
    'respData': {
        'spuId': '@id',
        'spuName': '@cword(10)',
        'corpId': '@id',
        'corpName': '@cword(10)',
        'salesVolume|100-500': 100,
        'priceFrom|500-1000': 500,
        'priceTo|1000-2000': 1000,
        'buyCondition': '100起售',
        'taxRate': 0.16,
        'attrBeans|5-10': [{
            'attrInfoName': '@cname(5)',
            'unit': 'unit',
            'attrValueName': '@cname(10)'
        }],
        'attachInfos|2': [{
            'type': 1,
            'url': '@image("600x600",@color)',
            'context': '# 商品详情 ![picture](https://dummyimage.com/%22600x600%22/7ff279)'
        },
        {
            'type': 2,
            'url': '',
            'context': '# 商品详情 ![picture](https://dummyimage.com/%22600x600%22/7ff279)'
        }],
        'skuInfos|2-5': [{
            'skuId': '@id',
            'skuName': '@cname',
            'model': '@cword(6)',
            'price|500-1000': 500,
            'attrBeans|5-10': [{
                'attrInfoName': '@cname(5)',
                'unit': 'unit',
                'attrValueName': '@cname(10)'
            }]
        }],
        'supplyTypeDisp': '@cname',
        'name': '@cname',
        'mobile': '17010997890',
        'provCodeDisp': '',
        'cityCodeDisp': '',
        'districtCodeDisp': '',
        'corpAddr': '@cword'

    }
});

export default MOCK030002


// WEBPACK FOOTER //
// ./src/mock/getProductDetail.js